'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _resource = require('../resource');

var _resource2 = _interopRequireDefault(_resource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Groups = function (_Resource) {
    (0, _inherits3.default)(Groups, _Resource);

    function Groups() {
        (0, _classCallCheck3.default)(this, Groups);
        return (0, _possibleConstructorReturn3.default)(this, (Groups.__proto__ || (0, _getPrototypeOf2.default)(Groups)).apply(this, arguments));
    }

    (0, _createClass3.default)(Groups, [{
        key: 'delete',


        /**
         * @api {delete} /v1/organizations/:organization_id/groups/:group_id delete
         * @apiGroup Groups
         * @apiName delete
         * @apiDescription Delete group. By default, child groups will be moved one level up. Optional parameter organization_id is ignored.
         * @apiParam {Number} organization_id
         * @apiParam {Number} group_id
         * @apiParam {Number} [cascade=0]
         * @apiExample {js} Example:
         *             gigwalk.groups.delete({...})
         */
        value: function _delete(params) {
            var data = {
                cascade: params.cascade ? params.cascade : 0
            };

            return this.client.delete('/v1/organizations/' + params.organization_id + '/groups/' + params.group_id, data);
        }

        /**
         * @api {get} /v1/organizations/:organization_id/groups/:group_id get
         * @apiGroup Groups
         * @apiName get
         * @apiDescription Get the information of a group. Optional parameter organization_id is ignored.
         * @apiParam {Number} organization_id
         * @apiParam {Number} group_id
         * @apiExample {js} Example:
         *             gigwalk.groups.get({...})
         */

    }, {
        key: 'get',
        value: function get(params) {
            return this.client.get('/v1/organizations/' + params.organization_id + '/groups/' + params.group_id);
        }

        /**
         * @api {put} /v1/organizations/:organization_id/groups/:group_id update
         * @apiGroup Groups
         * @apiName update
         * @apiDescription Update group. Optional parameter organization_id is ignored.
         * @apiParam {Number} organization_id
         * @apiParam {Number} group_id
         * @apiParam {Object} group
         * @apiExample {js} Example:
         *             gigwalk.groups.update({...})
         */

    }, {
        key: 'update',
        value: function update(params) {
            return this.client.put('/v1/organizations/' + params.organization_id + '/groups/' + params.group_id, (0, _extends3.default)({}, params.group));
        }

        /**
         * @api {get} /v1/groups/:group_id/sub_groups getSubgroups
         * @apiGroup Groups
         * @apiName getSubgroups
         * @apiDescription Get information about all the descendant groups of a group. All Subgroups will be fetched.
         * @apiParam {Number} group_id
         * @apiExample {js} Example:
         *             gigwalk.groups.getSubgroups({...})
         */

    }, {
        key: 'getSubgroups',
        value: function getSubgroups(params) {
            return this.client.get('/v1/groups/' + params.group_id + '/sub_groups');
        }

        /**
         * @api {get} /v1/group_hierarchy/:group_id getHierchy
         * @apiGroup Groups
         * @apiName getHierchy
         * @apiDescription If group_id is specified, return the hierarchy tree in which the group is present. Otherwise, return hierarchy for each group
                           the current user belongs to.
         * @apiParam {Number} group_id
         * @apiExample {js} Example:
         *             gigwalk.groups.getHierchy({...})
         */

    }, {
        key: 'getHierchy',
        value: function getHierchy(params) {
            if (params && params.group_id) return this.client.get('/v1/group_hierarchy/' + params.group_id);
            return this.client.get('/v1/group_hierarchy');
        }

        /**
         * @api {get} /v1/organizations/:organization_id/groups getForOrganization
         * @apiGroup Groups
         * @apiName getForOrganization
         * @apiDescription Platform admins get all groups, Admins get all groups of the organization, Workers get information about the groups they belong to.
         * @apiParam {Number} organization_id
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.groups.getForOrganization({...})
         */

    }, {
        key: 'getForOrganization',
        value: function getForOrganization(params) {
            var query = this.stringForQueryObject(params.query);

            return this.client.get('/v1/organizations/' + params.organization_id + '/groups' + query);
        }

        /**
         * @api {post} /v1/organizations/:organization_id/groups create
         * @apiGroup Groups
         * @apiName create
         * @apiDescription Create a group.
         * @apiParam {Number} organization_id
         * @apiExample {js} Example:
         *             gigwalk.groups.create({...})
         */

    }, {
        key: 'create',
        value: function create(params) {
            return this.client.post('/v1/organizations/' + params.organization_id + '/groups', (0, _extends3.default)({}, params.group));
        }

        /**
         * @api {get} /v1/groups/:group_id/customers getMembers
         * @apiGroup Groups
         * @apiName getMembers
         * @apiDescription Return information about the customers belonging to this group. Customers of descendant groups will also be returned.
         * @apiParam {Number} group_id
         * @apiParam {Number} [subgroup_members]
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.groups.getMembers({...})
         */

    }, {
        key: 'getMembers',
        value: function getMembers(params) {
            var query = this.stringForQueryObject(params.query);
            var data = {
                subgroup_members: params.subgroup_members ? params.subgroup_members : 0
            };

            return this.client.get('/v1/groups/' + params.group_id + '/customers' + query, data);
        }

        /**
         * @api {post} /v1/groups/:group_id/customers addMember
         * @apiGroup Groups
         * @apiName addMember
         * @apiDescription Add a member to a group.
         * @apiParam {Number} group_id
         * @apiParam {Object} member
         * @apiExample {js} Example:
         *             gigwalk.groups.addMember({...})
         */

    }, {
        key: 'addMember',
        value: function addMember(params) {
            return this.client.post('/v1/groups/' + params.group_id + '/customers', [(0, _extends3.default)({}, params.member)]);
        }

        /**
         * @api {put} /v1/groups/:group_id/customers updateMembers
         * @apiGroup Groups
         * @apiName updateMembers
         * @apiDescription Used for bulk updates or bulk removes.
         * @apiParam {Number} group_id
         * @apiParam {string} [action='remove']
         * @apiParam {Object[]} members
         * @apiExample {js} Example:
         *             gigwalk.groups.updateMembers({...})
         */

    }, {
        key: 'updateMembers',
        value: function updateMembers(params) {
            var data = {
                memberships: params.members,
                action: params.action ? params.action : 'remove'
            };

            return this.client.put('/v1/groups/' + params.group_id + '/customers', data);
        }

        /**
         * @api {delete} /v1/groups/:group_id/customers:customer_id removeMember
         * @apiGroup Groups
         * @apiName removeMember
         * @apiDescription Remove the given member from a group.
         * @apiParam {Number} customer_id
         * @apiParam {Number} group_id
         * @apiExample {js} Example:
         *             gigwalk.groups.removeMember({...})
         */

    }, {
        key: 'removeMember',
        value: function removeMember(params) {
            return this.client.delete('/v1/groups/' + params.group_id + '/customers/' + params.customer_id);
        }

        /**
         * @api {post} /v1/groups/:group_id/clone clone
         * @apiGroup Groups
         * @apiName clone
         * @apiDescription Clone a group and its subgroups.
         * @apiParam {Number} group_id
         * @apiParam {Number} [parent_id]
         * @apiParam {String} [suffix]
         * @apiExample {js} Example:
         *             gigwalk.groups.clone({...})
         */

    }, {
        key: 'clone',
        value: function clone(params) {
            var data = {
                parent_id: params.parent_id ? params.parent_id : 0,
                suffix: params.suffix ? params.suffix : ''
            };

            return this.client.post('/v1/groups/' + params.group_id + '/clone', data);
        }
    }]);
    return Groups;
}(_resource2.default);

exports.default = Groups;
//# sourceMappingURL=index.js.map